import Select from "react-select";
import React, { useState } from "react";

import { EMPTY_STRING } from "../../../constants";
import CategoriesDropdown from "../selectDropdown/CategoriesDropdown";
import { AddIcon, CloseIcon } from "../../../assets/icons/iconsProvider";
import {
  inputTagDropDownStyle,
  insertVariableShopifyField,
} from "../../../assets/scss/style";

const ShopifyTags = ({
  value,
  onChange,
  shopifyTags = [],
  isDisabled = false,
  placeHolder = EMPTY_STRING,
  name = "textareaWithInsertVariable",
  variableOptions = [{ value: "user_name", label: "User Name" }],
}) => {
  const [newTag, setNewTag] = useState("");

  const handleAddShopifyTags = (tag) => {
    if (!tag) return;
    // Avoid duplicates by checking value and isVariable
    const isDuplicate = (value || []).some(
      (t) =>
        typeof t === "object" &&
        t.value === tag.value &&
        t.isVariable === tag.isVariable
    );
    if (isDuplicate) return;
    onChange([...(value || []), tag]);
  };

  const handleVariableSelect = (selected) => {
    if (!selected) return;
    // Add variable tag with a key to denote it's a variable
    handleAddShopifyTags({ value: selected.value, isVariable: true });
  };

  const handleInputKeyDown = (e) => {
    if (e.key === ";" || e.key === "Semicolon") {
      e.preventDefault();
      handleAddTag(false);
    }
  };
  const handleInputChange = (query, { action }) => {
    if (action === "input-change") {
      setNewTag(query);
    }
  };
  const handleChange = (selectedOption) => {
    if (selectedOption) {
      // Add tag with a key to denote it's NOT a variable
      handleAddShopifyTags({ value: selectedOption.value, isVariable: false });
    }
  };

  const handleAddTag = () => {
    if (!newTag.trim()) return;
    handleAddShopifyTags({ value: newTag.trim(), isVariable: false });
    setNewTag("");
  };

  const handleRemoveTag = (tag) => {
    if (!value) return;
    onChange(
      value.filter((t) => {
        // Handle both string and object tags
        if (typeof t === "string" && typeof tag === "string") return t !== tag;
        if (typeof t === "object" && typeof tag === "object")
          return t.value !== tag.value || t.isVariable !== tag.isVariable;
        return true;
      })
    );
  };

  return (
    <div
      className={"d-flex flex-column position-relative shopify-tags-wrapper"}
    >
      <div className={"header shopify-tag-header"}>
        <div className="add-tag-wrapper">
          <Select
            value={EMPTY_STRING}
            options={shopifyTags?.map((tag) => ({
              value: tag.node,
              label: tag.node,
            }))}
            getOptionLabel={(e) => e.label}
            getOptionValue={(e) => e.value}
            isSearchable
            onKeyDown={handleInputKeyDown}
            placeholder={"Add Shopify Tag..."}
            components={{
              IndicatorSeparator: () => null,
            }}
            styles={inputTagDropDownStyle}
            onChange={handleChange}
            noOptionsMessage={() => {
              return "No Shopify Tags Found";
            }}
            onInputChange={handleInputChange}
          />

          <button type="button" onClick={() => handleAddTag(false)}>
            <AddIcon />
          </button>
        </div>
        <div className="category-dropdowns">
          <CategoriesDropdown
            value={""}
            isStartIcon={false}
            isClearable={false}
            disabled={isDisabled}
            options={variableOptions}
            placeholder={"Insert Variable"}
            handleChange={handleVariableSelect}
            noOptionsMessage={"No variables available"}
            styles={insertVariableShopifyField}
          />
        </div>
      </div>
      <div className="shopify-tags-inner-wrapper">
        {value?.length > 0 &&
          value?.map((tag) => {
            return (
              <div
                className={`tag ${
                  tag.isVariable ? "custom-variable" : "shopify-tag"
                }  `}
                onClick={() => handleRemoveTag(tag)}
              >
                {tag?.value}
                <span>
                  <CloseIcon className="add-tag-icon" />
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ShopifyTags;
